import FileSaver from 'file-saver';
// eslint-disable-line import/extensions
window.saveAs = FileSaver.saveAs;



// WEBPACK FOOTER //
// ./src/modules/utils/save-as-polyfill.js